import * as types from './types';
import Api from '../lib/api';

export function postApplicantAction(applicant) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.post('Applicant', applicant, true);
            dispatch(postApplicantResult(response.data.applicant_id ));
            return response.data.applicant_id;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function postApplicantResult(applicant_id) {
    return {
        type: types.APPLICANT_POST,
        applicant_id
    }
}

export function postApplicantProcessAction(id, applicantProcess) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.post('Applicant/' + id + '/process', applicantProcess);
            dispatch(postApplicantProcessResult(response.data.applicant_id ));
            return response.data;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function postApplicantProcessResult(applicant_id) {
    return {
        type: types.APPLICANT_PROCESS_POST,
        applicant_id
    }
}

export function getApplicantAction(limit=10, offset=0, filter=null) {
    return async (dispatch, getState) => {
        try{
            let response = null;
            if(filter === null) {
                response = await Api.get(`Applicant?limit=${limit}&offset=${offset}`);
            } else {
                response = await Api.post(`Applicant/Filter`, { limit: limit, offset: offset, filter: filter });
            }
            dispatch(getApplicantResult(response.data ));
            return response.data;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function getApplicantResult(data) {
    return {
        type: types.APPLICANT_GET,
        applicants: data.applicants,
        count: data.count
    }
}

export function getApplicantByIdAction(id) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.get('Applicant/'+id);
            dispatch(getApplicantByIdResult(response.data.applicant ));
            return response.data.applicant;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function getApplicantByIdResult(applicant) {
    return {
        type: types.APPLICANT_GET_BYID,
        applicant
    }
}



// WEBPACK FOOTER //
// ./src/actions/applicant.js